module.exports = __webpack_public_path__ + "img/6_8.ce824510.png";